import { useCallback } from 'react';

/**
 * Filter sites array down by active tab.
 */
export const useSiteList = ({ filterText }) => {
  /**
   * Filter sites array down by active tab.
   */
  const getFilteredSites = useCallback(
    (arr) => arr.filter((site) => site.site.name?.toLowerCase().includes(filterText)),
    [filterText],
  );

  /**
   * Filter asset array down by active tab.
   */
  const getFilteredAssets = useCallback(
    (arr) =>
      arr?.filter((asset) => {
        return (
          asset.name?.toLowerCase().includes(filterText) ||
          asset.state?.value?.toLowerCase().includes(filterText)
        );
      }),
    [filterText],
  );

  return [getFilteredSites, getFilteredAssets];
};
